// Data-driven product galleries. First image = clean primary product photo,
// followed by curated catalogue feature images extracted from product PDFs
// (served as optimized WebP static assets from /public/product-gallery/<slug>).

const slides = (slug, count) =>
  Array.from({ length: count }, (_, i) => `/product-gallery/${slug}/${String(i + 1).padStart(2, '0')}.webp`);

const build = (slug, name, primary, count) => [
  { src: primary, alt: `${name} product photo` },
  ...slides(slug, count).map((src, i) => ({ src, alt: `${name} - feature view ${i + 1}` })),
];

export const PRODUCT_GALLERIES = {
  'escargot-commercial': build(
    'escargot-commercial',
    'Harpalyk SMARTBOT Escargot commercial floor cleaning robot',
    'https://customer-assets.emergentagent.com/job_80fffe0f-7ad4-44ce-aa36-08a4bccc4edb/artifacts/78savfvp_jan.png',
    6
  ),
  'hygienx-300': build(
    'hygienx-300',
    'Harpalyk SMARTBOT HygienX 300 robot vacuum and mop',
    'https://customer-assets.emergentagent.com/job_80fffe0f-7ad4-44ce-aa36-08a4bccc4edb/artifacts/4ik16avb_PHOTO-2026-05-30-18-18-13.jpg',
    9
  ),
  'robo-dressel': [
    { src: 'https://customer-assets-jt897jd0.emergentagent.net/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/3y07x1gj_aee2706b-9652-4a2b-8c52-5c06900c5667.png', alt: 'Harpalyk POOLBOT Robo Dressel robotic pool cleaner — product photo' },
    { src: 'https://customer-assets.emergentagent.com/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/fent140v_PHOTO-2026-06-29-17-37-52.jpg', alt: 'Harpalyk POOLBOT Robo Dressel robotic pool cleaner — with caddy' },
    { src: 'https://customer-assets.emergentagent.com/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/und2cyfg_PHOTO-2026-06-29-20-46-15.jpg', alt: 'Harpalyk POOLBOT Robo Dressel robotic pool cleaner — components' },
    ...slides('robo-dressel', 8).map((src, i) => ({ src, alt: `Harpalyk POOLBOT Robo Dressel robotic pool cleaner - feature view ${i + 1}` })),
  ],
  'robo-titan': build(
    'robo-titan',
    'Harpalyk POOLBOT Robo Titan commercial pool cleaning robot',
    'https://customer-assets.emergentagent.com/job_smart-living-18/artifacts/y34dz1wb_PHOTO-2025-12-24-16-57-25.jpg',
    7
  ),
  'luminex-300': [
    { src: 'https://customer-assets-jt897jd0.emergentagent.net/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/unyfq400_8.%20LumineX%20300.png', alt: 'Harpalyk SMARTBOT LumineX 300 robot vacuum and mop — product photo' },
    { src: 'https://customer-assets-jt897jd0.emergentagent.net/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/unyfq400_8.%20LumineX%20300.png', alt: 'Harpalyk SMARTBOT LumineX 300 robot vacuum and mop — features' },
    ...slides('luminex-300', 4).map((src, i) => ({ src, alt: `Harpalyk SMARTBOT LumineX 300 robot vacuum - feature view ${i + 1}` })),
  ],
  'shinebot-c2': build(
    'shinebot-c2',
    'Harpalyk SHINEBOT ShineBot C2 window cleaning robot',
    'https://customer-assets.emergentagent.com/job_smart-living-18/artifacts/6j2kav5l_Window%20robo.jpeg',
    9
  ),
};

export default PRODUCT_GALLERIES;
